import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './Services/serviceWorker';

import Keycloak from 'keycloak-js';

const REDIRECT_URI = window.location.origin + '/';

export function logoutKeycloak() {
    window.sessionStorage.clear();
    keycloak.logout({ redirectUri: REDIRECT_URI }).catch(() => {
        console.log("keycloak logout failed.");
        window.location.reload();
    });
}

function refreshKeycloakToken() {
    if (keycloak.isTokenExpired(10 + (keycloak.timeSkew ? keycloak.timeSkew : 0))) {
        keycloak.updateToken(-1)
            .then(refreshed => {
                if (refreshed) {
                    if (keycloak.isTokenExpired(10 + (keycloak.timeSkew ? keycloak.timeSkew : 0))) {
                        logoutKeycloak();
                    } else {
                        window.sessionStorage.setItem("loginToken", keycloak.token || "");
                    }
                } else {
                    console.log('Token is still valid');
                }
            })
            .catch(() => {
                console.log('Failed to refresh the token, or the session has expired');
                logoutKeycloak();
            });
    }
}

// A valid OAuth callback always contains 'state'. Strip any stale fragment
// (e.g. accumulated #iss= params from a previous failed redirect loop)
// so keycloak-js does not misinterpret it as an authorization response.
const hashParams = new URLSearchParams(window.location.hash.substring(1));
if (window.location.hash && !hashParams.get('state')) {
    window.history.replaceState(null, '', window.location.pathname);
}

export const keycloak = new Keycloak({
    url: 'https://sso.tazi.ai/auth',
    realm: 'TaziLicense',
    clientId: 'TaziLicenseManager',
});

keycloak.init({ onLoad: 'login-required', checkLoginIframe: false, redirectUri: REDIRECT_URI, useNonce: false })
    .then(() => {
        window.sessionStorage.setItem("loginToken", keycloak.token || "");
        setInterval(refreshKeycloakToken, 10000);
        ReactDOM.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>,
            document.getElementById('root')
        );
    })
    .catch(err => {
        console.error('Keycloak init failed:', err);
    });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
